import React from 'react';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { useQueryWithStore, useNotify, useRefresh } from 'react-admin';
import moment from 'moment';

import useSupplyStyles from '../controls/SupplyStyles';
import supplyPost from '../controls/supplyApi';

const STATUS_LABEL = {
    CREATED: 'Created',
    OPEN: 'Open',
    CLOSED: 'Closed',
    EXPIRED: 'Expired',
};

/** Sublot grid for calibration supplies - only one sublot may be open at a time. */
const SublotPanel = ({ record }) => {
    const classes = useSupplyStyles();
    const notify = useNotify();
    const refresh = useRefresh();

    const { data, loaded } = useQueryWithStore({
        type: 'getList',
        resource: 'supplysublots',
        payload: {
            filter: { receipt_id: record ? record.id : 0 },
            sort: { field: 'sublot_no', order: 'ASC' },
            pagination: { page: 1, perPage: 200 },
        },
    });

    if (!record || !record.has_sublots) { return null; }
    if (!loaded) { return null; }

    const sublots = data || [];
    const hasOpen = sublots.some(s => s.status === 'OPEN');

    const run = (id, action, okMessage) => {
        supplyPost(`supplysublots/${id}/${action}`, {})
            .then(() => {
                notify(okMessage);
                refresh();
            })
            .catch(error => {
                notify(
                    (error && error.body) || (error && error.message) || 'Action failed',
                    'warning'
                );
            });
    };

    return (
        <React.Fragment>
            <Typography className={classes.sectionTitle}>Sublots</Typography>
            <Table size="small">
                <TableHead className={classes.tableHead}>
                    <TableRow>
                        <TableCell className={classes.tableHeadCell}>Sublot #</TableCell>
                        <TableCell className={classes.tableHeadCell}>Status</TableCell>
                        <TableCell className={classes.tableHeadCell}>Usages</TableCell>
                        <TableCell className={classes.tableHeadCell}>Open Date/Time</TableCell>
                        <TableCell className={classes.tableHeadCell}>Expiry Date</TableCell>
                        <TableCell className={classes.tableHeadCell}>Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sublots.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={6}>No sublots for this lot.</TableCell>
                        </TableRow>
                    )}
                    {sublots.map(sublot => (
                        <TableRow key={sublot.id}>
                            <TableCell>{sublot.sublot_no}</TableCell>
                            <TableCell>{STATUS_LABEL[sublot.status] || sublot.status}</TableCell>
                            <TableCell>{sublot.usages}</TableCell>
                            <TableCell>
                                {sublot.open_datetime
                                    ? moment(sublot.open_datetime).format('MM/DD/YYYY HH:mm')
                                    : ''}
                            </TableCell>
                            <TableCell>
                                {sublot.expiry_date
                                    ? moment(sublot.expiry_date).format('MM/DD/YYYY')
                                    : ''}
                            </TableCell>
                            <TableCell>
                                {sublot.status === 'OPEN' && (
                                    <React.Fragment>
                                        <Link
                                            component="button"
                                            onClick={() => run(sublot.id, 'use', 'Usage recorded')}
                                        >
                                            Use
                                        </Link>
                                        {'  |  '}
                                        <Link
                                            component="button"
                                            onClick={() => run(sublot.id, 'close', 'Sublot closed')}
                                        >
                                            Close
                                        </Link>
                                    </React.Fragment>
                                )}
                                {sublot.status === 'CREATED' && !hasOpen && (
                                    <Link
                                        component="button"
                                        onClick={() => run(sublot.id, 'open', 'Sublot opened')}
                                    >
                                        Open
                                    </Link>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </React.Fragment>
    );
};

export default SublotPanel;
